/*
 * @Author: Teemo Ding
 * @Date: 2022-08-04 16:19:09
 * @LastEditTime: 2023-02-01 09:17:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/common.ts
 */
import { get } from 'lodash';
export const discountCalculate = (discountSelections) => {
  // 处理discount结构
  const gift = (discountSelections || []).map((item) => ({
    discountUuid: get(item, 'discount.uuid'),
    freeGift: get(item, 'freeGift'),
    items: (get(item, 'giftSelection.products') || []).filter((o) => o.checked),
  }));
  const gwp = (gift || []).filter((o) => o.freeGift && o.items);
  const pwp = (gift || []).filter((o) => !o.freeGift && o.items);
  //后端指定结构
  return { giftPurchases: pwp, freeGifts: gwp };
};
